import { useState, useEffect } from 'react';

interface DeviceDetectionResult {
  isMobile: boolean;
  isIOS: boolean;
  isSafari: boolean;
  isIOSSafari: boolean;
  shouldUseRedirect: boolean;
}

export const useDeviceDetection = (): DeviceDetectionResult => {
  const [deviceInfo, setDeviceInfo] = useState<DeviceDetectionResult>({
    isMobile: false,
    isIOS: false,
    isSafari: false,
    isIOSSafari: false,
    shouldUseRedirect: false
  });

  useEffect(() => {
    const userAgent = navigator.userAgent || '';
    
    // Detect mobile devices
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent) || 
                     window.innerWidth <= 768 || 
                     'ontouchstart' in window;
    
    // Detect iOS
    const isIOS = /iPad|iPhone|iPod/.test(userAgent);
    
    // Detect Safari
    const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);
    
    // Detect iOS Safari specifically
    const isIOSSafari = isIOS && isSafari;
    
    // Determine if we should use redirect instead of popup
    // Use redirect for iOS Safari, Facebook in-app browser, or any mobile browser
    const shouldUseRedirect = isIOSSafari || 
                             userAgent.includes('FBAN') || 
                             userAgent.includes('FBAV') || 
                             userAgent.includes('FB_IAB') ||
                             (isMobile && isSafari);
    
    setDeviceInfo({
      isMobile,
      isIOS,
      isSafari,
      isIOSSafari,
      shouldUseRedirect
    });
  }, []);

  return deviceInfo;
}; 